import dev from './config.dev';
import prod from './config.prod';
import staging from './config.staging';

export const configSetting = process.env.REACT_APP_ENV === "PROD" ? prod : process.env.REACT_APP_ENV === "STAGING" ? staging : dev;
